import { useEffect, useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { ComunicacionRiesgo } from "./ComunicacionRiesgo";
import { PlanContingencia } from "./PlanContingencia";
import { ProgressSpinner } from "primereact/progressspinner";

export const Contingencias = ({ riesgo, id, toast, permss, generic, seccion, nextPrev, handleNext, registrar, funcionalidades }) => {

    const matrizSrv = new MonitoreoService();
    const [catalogos, setCatalogos] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        consultar();
    }, []);

    const consultar = () => {
        setLoading(true);
        matrizSrv.consultar(`${id}/${riesgo?.id}/${seccion}`, 'matriz-riesgo-detalle/consulta').then(res => {
            setCatalogos(res.data?.catalogos);
        }).finally(() => {
            setLoading(false);
        });
    }

    return (
        <>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Cargando información...</span>
                </div>
            ) : (
                <div>
                    <ComunicacionRiesgo riesgo={riesgo} id={id} toast={toast} permss={permss} generic={generic} seccion={seccion} registrar={registrar} catalogos={catalogos} funcionalidades={funcionalidades} />
                    <br />
                    <PlanContingencia riesgo={riesgo} id={id} toast={toast} permss={permss} generic={generic} seccion={seccion} registrar={registrar} catalogos={catalogos} funcionalidades={funcionalidades} />
                    {nextPrev('solo-control-atras')}
                </div>
            )}
        </>
    )
}
